import React, { useEffect, useState } from "react";
import { BiAddToQueue } from "react-icons/bi";

import { useForm } from "react-hook-form";
import "./viewEditMyRestaurant.scss";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import AddDish from "./addDish/addDish";
import addLogo from "../../../assets/addLogo.png";
import UploadCropImg from "../../../components/commonComponents/upload-crop-img/uploadCropImg";
import { BiChevronUpCircle } from "react-icons/bi";
import ScrollToTopButton from "../../commonComponents/go-up-button/scrollToTopButton";
import { BsThreeDotsVertical } from "react-icons/bs";
import Settings from "./settings/settings";

function ViewEditMyRestaurant() {
  const [myRestaurantData, setMyRestaurantData] = useState("");
  const [toggleAddingbutton, settoggleAddingbutton] = useState(true);
  const [menuSection, setMenuSection] = useState([]);
  const [toggleSavebutton, settoggleSavebutton] = useState(false);
  const [toggleAddingDishbutton, setToggleAddingDishbutton] = useState(false);
  const [menuSectionIndex, setMenuSectionIndex] = useState(0);
  const [reloadDishes, setReloadDishes] = useState(false);
  const [dishObject, setDishObject] = useState([]);
  const [dishesSavedSuccessfully, setDishesSavedSuccessfully] = useState(false);
  const [toggleEditMyRestaurant, setToggleEditMyRestaurant] = useState(false);
  const [showSettingsMyRestaurant, setShowSettingsMyRestaurant] =
    useState(false);
  const [rernderMyRestaurant, setRernderMyRestaurant] = useState(false);
  const [menuSectionDeleted, setMenuSectionDeleted] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    // Read the existing dishObject array from sessionStorage
    const storedDishObject = sessionStorage.getItem("dishes");
    if (storedDishObject) {
      setDishObject(JSON.parse(storedDishObject));
      settoggleSavebutton(true);
      setDishesSavedSuccessfully(false);
    } else {
      settoggleSavebutton(false);
      setDishesSavedSuccessfully(true);
    }
    console.log(dishObject);
  }, [reloadDishes]);
  useEffect(() => {
    async function getMyRestaurantData() {
      await fetch("https://femez.onrender.com/API/restaurant/getMyRestaurant", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            return res.json();
          } else {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
        })
        .then((data) => {
          setMyRestaurantData(data.myRestaurant);
          console.log(data.myRestaurant);

          const uniqueSectionNames = [
            ...new Set(
              data.myRestaurant.menu_sections.map((item) => item.section_name)
            ),
          ];

          const storedMenuSection = sessionStorage.getItem("menuSection");
          if (storedMenuSection) {
            setMenuSection(JSON.parse(storedMenuSection));
            settoggleSavebutton(true);
          } else {
            setMenuSection(uniqueSectionNames);
          }

          console.log(menuSection);
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    }
    getMyRestaurantData();
  }, [reloadDishes, rernderMyRestaurant, menuSectionDeleted]);
  useEffect(() => {
    if (reloadDishes) {
      console.log("Dishes reloaded!");
      setReloadDishes(false);
    }
  }, [reloadDishes]);

  const addNewMenuSection = (data) => {
    console.log("im here in addNewMenuSection", data);

    // Check if the menu_section_name already exists in the array
    if (!menuSection.includes(data.menu_section_name)) {
      // Check if the maximum size is reached
      if (menuSection.length < 20) {
        // Add the new menu_section_name if it's unique
        setMenuSection((prevSections) => {
          const newSections = [...prevSections, data.menu_section_name];
          sessionStorage.setItem("menuSection", JSON.stringify(newSections));
          return newSections;
        });
        settoggleSavebutton(true);
      } else {
        window.alert("Maximum size reached. Cannot add more elements.");
      }
    } else {
      window.alert("Menu section name must be unique.");
    }

    console.log(menuSection);
  };

  const base64ToBlob = (base64String) => {
    const byteCharacters = atob(base64String.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: "image/jpeg" }); // Adjust the type as needed
  };
  const sendDataToServer = async () => {
    const storedDishes = sessionStorage.getItem("dishes");
    const storedMenuSection = sessionStorage.getItem("menuSection");

    console.log(storedMenuSection);
    if (storedMenuSection) {
      await fetch("https://femez.onrender.com/API/restaurant/addSectionDish", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ storedMenuSection }),
      })
        .then((res) => {
          if (res.status === 200) {
            return res.json();
          } else {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
        })
        .then((data) => {
          sessionStorage.removeItem("menuSection");
          settoggleSavebutton(false);
          console.log(
            "Section added successfully and/or diches added successfully"
          );
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    }

    if (storedDishes) {
      // Create an array to store FormData instances
      const formDataArray = [];
      console.log(storedDishes);
      // Iterate through each item in storedDishes
      const formData = new FormData();
      JSON.parse(storedDishes).forEach((dish) => {
        console.log(dish);
        // Create a new FormData instance for each dish

        // Append data to the FormData instance
        if (dish.img) {
          // Assuming 'img' is a valid property in your dish object
          const blobImage = base64ToBlob(dish.img);
          console.log(blobImage);
          formData.append(
            "dishImage",
            blobImage,
            myRestaurantData.restaurant_name
          );
        }

        formData.append("dishName", dish.dishName);
        formData.append("dishDescription", dish.dishDescription);
        formData.append("dishPrice", dish.dishPrice);
        formData.append("menuSectionIndex", dish.menuSectionIndex);

        // Add the FormData instance to the array
        formDataArray.push(formData);
      });
      console.log(formData);
      // Now formDataArray contains FormData instances for each dish
      // Use formDataArray in your fetch request

      fetch("https://femez.onrender.com/API/restaurant/addDishes", {
        method: "POST",
        headers: {
          enctype: "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: formData,
      })
        .then((res) => {
          if (res.status === 200) {
            return res.json();
          } else {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
        })
        .then((data) => {
          sessionStorage.removeItem("dishes");
          setReloadDishes(true);
          setDishesSavedSuccessfully(true);
          settoggleSavebutton(true);
          console.log("Dishes added successfully");
        });
    }
  };

  const cancelAddingNewMenuSection = () => {
    settoggleAddingbutton(!toggleAddingbutton);
  };

  const cancelAddingNewDish = () => {
    setToggleAddingDishbutton(false);
  };
  const showSettingsButton = () => {
    setToggleEditMyRestaurant(true);
  };
  const showSettings = () => {
    console.log("showSettings");
    setShowSettingsMyRestaurant(true);
  };
  const handlePageClick = (event) => {
    console.log("toggleEditMyRestaurant", toggleEditMyRestaurant);

    if (toggleEditMyRestaurant && !event.target.closest(".dots-icon")) {
      setToggleEditMyRestaurant(false);
    }
  };

  window.addEventListener("click", handlePageClick);

  const handleDelete = (index) => {
    if (window.confirm("Are you sure you want to delete this menu section?")) {
      console.log(index);

      // If confirmed, send a request to the server to delete the menu section
      console.log(menuSection[index]);
      console.log(menuSection[index]._id);
      fetch(
        `https://femez.onrender.com/API/restaurant/deleteElementInMenuSection/${index}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            // If deletion is successful, update the menu sections state
            const updatedMenuSections = [...menuSection];
            updatedMenuSections.splice(index, 1);
            setMenuSection(updatedMenuSections);
            setMenuSectionDeleted(!menuSectionDeleted);
          } else {
            // Handle error response from server
            console.error("Failed to delete menu section");
          }
        })
        .catch((error) => console.error("Error:", error));
    }
  };
  return (
    <div className="MyRestaurant-container">
      <ScrollToTopButton />
      <div className="cover">
        <img src={`https://femez.onrender.com/${myRestaurantData.cover}`} />
        <img src={addLogo} className="restaurant-logo">
          {/* <UploadCropImg widthCrop={100} heightCrop={100} /> */}
        </img>
      </div>
      <div className="restaurant-details">
        <label className="restaurant-name">
          {myRestaurantData.restaurant_name}
        </label>
        <label className="restaurant-category">
          {myRestaurantData.restaurant_category}
        </label>
        <div className="restaurant-settings-container">
          <BsThreeDotsVertical
            onClick={showSettingsButton}
            className="dots-icon"
          />
          {toggleEditMyRestaurant && (
            <div className="restaurant-settings" onClick={showSettings}>
              more settings
            </div>
          )}
        </div>
      </div>

      <div className="menu-sections-container-edit-my-restaurant">
        <div className="menu-sections">
          {toggleAddingbutton && (
            <div
              className="new-menu-sections"
              onClick={() => settoggleAddingbutton(!toggleAddingbutton)}
            >
              <div>
                <BiAddToQueue />
              </div>
              <label>Add new menu section</label>
            </div>
          )}
          {!toggleAddingbutton && (
            <div>
              <form onSubmit={handleSubmit(addNewMenuSection)}>
                <input
                  type="text"
                  id="menu_section_name"
                  placeholder="Add menu section name"
                  {...register("menu_section_name", {
                    required: true,
                    validate: (value) => value.trim().length > 0,
                    minLength: 2,
                    maxLength: 100,
                  })}
                />
                <>
                  {errors.menu_section_name &&
                    errors.menu_section_name.type === "required" && (
                      <span className="error-message">
                        This field is required
                      </span>
                    )}
                  {errors.menu_section_name &&
                    errors.menu_section_name.type === "validate" && (
                      <span className="error-message">
                        The name-surname cannot be empty
                      </span>
                    )}
                  {errors.menu_section_name &&
                    errors.menu_section_name.type === "minLength" && (
                      <span className="error-message">
                        the Length of the name-surname must be greater than or
                        equal 2 characters
                      </span>
                    )}
                  {errors.menu_section_name &&
                    errors.menu_section_name.type === "maxLength" && (
                      <span className="error-message">
                        the Length of the name-surname must be less than or
                        equal to 100 characters
                      </span>
                    )}
                </>
                <div className="form-buttons">
                  <button type="submit">Add</button>
                  <button onClick={cancelAddingNewMenuSection}>Cancel</button>
                </div>
              </form>
            </div>
          )}
          <div>
            {menuSection.map((section, index) => (
              <div key={`section-${index} `} className="menu-section-item">
                <div className="menu-section-name">{section}</div>
                <div className="edit-icon">
                  {/* <FaEdit /> */}
                  {!toggleSavebutton && (
                    <FaTrash onClick={() => handleDelete(index)} />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="menu-sections-content">
          <div className="menu-sections-dishes">
            {menuSection.map((section, index) => (
              <div key={`section-${index} `} className="menu-section-item">
                <div className="menu-section-content">
                  <div className="menu-section-name"> {section}</div>
                  <div
                    className="new-dish-menu-sections"
                    onClick={() => {
                      setToggleAddingDishbutton(true);
                      setMenuSectionIndex(index);
                    }}
                  >
                    <div>
                      <BiAddToQueue />
                    </div>
                    <label>Add new dish</label>
                  </div>

                  {/* Display dishes for the selected menu section */}

                  {(myRestaurantData.menu_sections[index] &&
                    myRestaurantData.menu_sections[index].dishes &&
                    myRestaurantData.menu_sections[index].dishes.length > 0) ||
                  dishObject.length > 0 ? (
                    <div className="dishes-list">
                      {myRestaurantData.menu_sections[index] &&
                        myRestaurantData.menu_sections[index].dishes.map(
                          (dish, dishIndex) => (
                            <div
                              key={`dish-${dish._id.$oid}-${dishIndex}`}
                              className="dish-item"
                            >
                              <div className="dish-details">
                                <div>
                                  <h3>{dish.dish_name}</h3>
                                  <p>{dish.dish_description}</p>
                                </div>
                                <h3>Price: {dish.dish_price} € </h3>
                              </div>
                              <div>
                                {dish.dish_image && (
                                  <img
                                    src={`https://femez.onrender.com/${dish.dish_image}`}
                                  />
                                )}
                              </div>
                            </div>
                          )
                        )}
                      {!dishesSavedSuccessfully &&
                        dishObject
                          .filter((dish) => index === dish.menuSectionIndex)
                          .map((dish, dishIndex) => (
                            <div
                              key={`unsaved_dish-${index}-${dishIndex}`}
                              className="dish-item"
                            >
                              <div className="dish-details">
                                <div>
                                  <h3>{dish.dishName}</h3>
                                  <p>{dish.dishDescription}</p>
                                </div>
                                <h3>Price: {dish.dishPrice} € </h3>
                              </div>
                              <div>
                                {dish.img && (
                                  <img
                                    src={dish.img}
                                    alt={`Dish ${index + 1}`}
                                  />
                                )}
                              </div>
                            </div>
                          ))}
                    </div>
                  ) : (
                    <p>No dishes available in this section yet</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {toggleSavebutton && (
          <div className="save-button-container">
            <button className="save_button" onClick={sendDataToServer}>
              Save After Completing All Edits
            </button>
          </div>
        )}
        {toggleAddingDishbutton && (
          <div className="add-dish-container">
            <AddDish
              onCancel={cancelAddingNewDish}
              restaurantName={myRestaurantData.restaurant_name}
              menuSectionIndex={menuSectionIndex}
              setReloadDishes={setReloadDishes}
              setToggleAddingDishbutton={setToggleAddingDishbutton}
            />
          </div>
        )}
      </div>
      {showSettingsMyRestaurant && (
        <Settings
          setShowSettingsMyRestaurant={setShowSettingsMyRestaurant}
          restaurantName={myRestaurantData.restaurant_name}
          restaurantCategory={myRestaurantData.restaurant_category}
          rernderMyRestaurant={rernderMyRestaurant}
          setRernderMyRestaurant={setRernderMyRestaurant}
          phone={myRestaurantData.phone}
        />
      )}
    </div>
  );
}
export default ViewEditMyRestaurant;
